@let favorites = favoritesStationsSignal();
@if (favorites?.length > 0) {
  <div class="container-grid">
    @for (favorite of favorites; track favorite.id) {
      <button class="grid-element" (click)="onClickFavorite(favorite)">


        @if ((getIconContent(favorite) | async); as icon) {
          <img [src]="dynamicContentUrlSignal() + icon" [alt]="">
        }
        <h2>{{favorite.title[translate.getCurrentLang()]}}</h2>

        <button (click)="onClickDeleteFavorite($event, favorite.id)">{{'delete' | translate}}</button>
      </button>
    }
  </div>

} @else {
  <div class="container-empty">
    <p class="text-center">{{'tipps_text_1' | translate}}</p>
    <h2 class="text-center">{{'tipps_title_1' | translate}}</h2>
    <ol>
      <li>{{'tipps_text_2' | translate}}</li>
      <li>{{'tipps_text_4' | translate}}</li>
    </ol>
    <p class="text-center">{{'tipps_text_5' | translate}}
      <mat-icon svgIcon="Icons_BOOKMARK_ADD"></mat-icon>
    </p>

  </div>
}

<div class="container-dialog container-dialog-main-goal"
  #popoverDeleteFavorite
  popover="auto">

  <p>Möchtest du den Tipp wirklich aus der Merkliste entfernen? Du kannst ihn jederzeit wieder deiner Merkliste hinzufügen.</p>

    <div class="container-button-center">
    <button  matButton="filled"
      class="button-rounded-center" color="accent"
      (click)="deleteCurrentSelectedFavorite()">
      {{'delete' | translate}}
      </button>

    <button  matButton="filled"
      class="button-rounded-center" color="accent"
      (click)="popoverDeleteFavorite.hidePopover()">
      {{'cancel' | translate}}
      </button>
  </div>

</div>